import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { deviceDetector } from '@/helpers/deviceDetector'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'

import dayjs from 'dayjs'

import s from './styles.module.scss'

const SuprademoTourModal = () => {
  const isMobile = deviceDetector()
  const [open, setOpen] = useState(false)
  const [canShowButton, setCanShowButton] = useState(false)
  const { creationDate: centreCreationDate } = useSelector((state) => state.centres.centreProfile)

  const TOUR_URLS = {
    mobile: 'https://app.supademo.com/embed/cmij2nffd0006yq0ib3k4lqc4?embed_v=2&utm_source=embed',
    desktop: 'https://app.supademo.com/embed/cmi37v1c422qgqnb945ejy14r?embed_v=2&utm_source=embed',
  }

  const src = isMobile ? TOUR_URLS.mobile : TOUR_URLS.desktop

  useEffect(() => {
    const alreadyShown = localStorage.getItem('DEMO_SUPRA_TOUR')
    if (!alreadyShown) {
      setOpen(true)
    }

    const today = dayjs()
    const creationDate = dayjs(centreCreationDate)
    const dayDiff = today.diff(creationDate, 'day')

    if (dayDiff >= 0 && dayDiff <= 2) {
      setCanShowButton(true)
    }
  }, [centreCreationDate])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    localStorage.setItem('DEMO_SUPRA_TOUR', 'true')
    setOpen(false)
  }

  return (
    <>
      {canShowButton && (
        <IconButton onClick={handleOpen} className={s.floatingBtn} disableRipple disableFocusRipple>
          <OndemandVideoIcon />
        </IconButton>
      )}

      <Dialog disableEscapeKeyDown open={open} onClose={handleClose} maxWidth="md" classes={{ paper: s.paperProps }}>
        <DialogTitle className={s.dialogTitle}>
          <Button className={s.closeBtn} onClick={handleClose}>
            X
          </Button>
        </DialogTitle>

        <DialogContent className={s.mainContainer}>
          <iframe
            title="Tour interactivo de Calu"
            src={src}
            width="100%"
            height="600"
            allow="fullscreen; autoplay"
            className={s.iframeStyle}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default SuprademoTourModal
